namespace GeniuzPOS.InventoryReport {
    export interface IcReportEomDtReportData extends Serenity.ListRequest {
        Header?: IcReportEomRow;
        Details?: IcReportWhsEomRow[];
        SkuCode?: string;
    }
}
